import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { useAuth } from './state/auth';

// Dev-only: #devlogin=<name> mints a local session (see /api/auth/dev-login,
// registered only when NODE_ENV=development). Used for e2e / manual testing.
// Resolves before first render so AuthGuard doesn't race the mint and bounce
// to /login. The auth store initialises at module-eval time — earlier than
// this promise — so the fresh token must be pushed into the store explicitly,
// not just into localStorage.
async function resolveDevLogin(): Promise<void> {
  if (!import.meta.env.DEV) return;
  const m = window.location.hash.match(/[#&]devlogin=([\w.-]+)/);
  if (!m) return;
  const username = m[1]!;
  try {
    const r = await fetch('/api/auth/dev-login', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ username }),
    });
    const d = r.ok ? ((await r.json()) as { accessToken?: string }) : null;
    if (d?.accessToken) {
      localStorage.setItem('bb_token', d.accessToken);
      useAuth.setState({ token: d.accessToken, user: null });
    }
  } catch {
    /* fall through — App will bounce to /login as usual */
  }
  window.location.hash = '';
}

resolveDevLogin().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
